import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  // <React.StrictMode>
    // Outermost: theme is a pure UI concern with no auth dependency, so login/register
    // and everything else theme together.
    <ThemeProvider>
      <App />
    </ThemeProvider>
  // </React.StrictMode>
);
